export const cleanDuplicates = (items, idItem, generateUniqueId = false) => {
  const finalIdValues = typeof idItem === 'string'
                        ? [idItem]
                        : idItem
  const finalItems = items.reduce((ac, current) => {
    let id = '';
    for (let i = 0; i < finalIdValues.length; i++) {
      id += `${current[finalIdValues[i]] || ''}`
    } 
    if (!ac[id]) {
      ac[id] = generateUniqueId ? {id, ...current} : current;
    }
    return ac;
  }, {});

  return Object.values(finalItems);
}

export const formatNumber = (num) => {
  if (!num) return '0.00';
  return num.toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};